import React from 'react';
import { Modal, Result, Space, Typography } from 'antd';
import { CheckCircleOutlined, ExclamationCircleOutlined } from '@ant-design/icons';
import PropTypes from 'prop-types';

const BuilderResult = ({ success, title, subTitle, isOpen, closeModal }) => {
  const status = success ? 'success' : 'error';
  const color = success ? '#036D40' : 'red';
  const icon = success ? <CheckCircleOutlined style={{color}} /> : <ExclamationCircleOutlined style={{color}} />;
  const fontFamily = 'Quicksand, sans-serif';


  return (
    <Modal
      open={isOpen}
      footer={null}
      onCancel={closeModal}
      className={success ? 'builder-result-success' : 'builder-result-failure'}
      style={{width: 600}}

    >
      <Result
        icon={icon}
        status={status}
        title={<Typography.Title level={2} style={{color, fontFamily}}>{title}</Typography.Title>}
        subTitle={
        <Space direction={'vertical'}>
          <Typography.Text style={{color, fontFamily}} strong>{subTitle}</Typography.Text>
          <Typography.Text style={{color, fontFamily, fontSize: '14px'}}>Allow up to 10 minutes for the updates to propogate. However it should take ~15-30 seconds before available</Typography.Text>
        </Space>
        }
        style={{ backgroundColor: 'transparent', color }}
      />
    </Modal>
  );
};

BuilderResult.propTypes = {
  success: PropTypes.bool.isRequired,
  title: PropTypes.string,
  subTitle: PropTypes.string,
  isOpen: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
};

export default BuilderResult;
